import React from 'react';
import PageMenu from './PageMenu';

function MenuResources(props) {
  return (
    <PageMenu
      {...props}
      title="Homebuyer Resources Menu"
      items={[
        {
          name: 'design-center',
          title: 'Design Center',
        },
        {
          name: 'hoa-request',
          title: 'Documents',
        },
        {
          name: 'about-the-developer',
          title: 'About The Developer',
        },
      ]}
    />
  );
}

export default MenuResources;



// WEBPACK FOOTER //
// ./src/components/MenuResources.js